import { EventEmitter } from '../EventEmitter'

import { storage } from '../utils/tools'
let test = {
    url: '/',
    appName: '',
    before: () => true,
    after: () => true
}
let routerConfig = []

let urlParam = new Map()

let historys = []
export default class Router extends EventEmitter {
    constructor(proc) {
        super()
        this.proc = proc
        this.params = {}

        this.Application = proc.make('Application')


    }
    historyApp = [];
    onlyApp = []
    router(val) {
        if (Array.isArray(val)) return;
        // 当前运行的应用

        val.forEach(item => {
            this.on(item.url, (param) => {
                if (item.before && !item.before(this.oldUrl, this.newUrl)) return;
                
                this.Application.run(item.appName)
                
            })
        })

        routerConfig = val
    }


    cache = {};
    on(key, value) {
        let cache = this.cache;
        cache[key] = value;
    };

    trigger(hash) {
        let cache = this.cache;
        for (let r in cache) {
            let reg = this.initRegexps(r);
            if (reg.test(hash)) {
                let callback = cache[r];
                if (!callback) return
                let params = this.getParams(reg, hash);
                callback.apply(this, params);
            }
        }
    };
    init() {
        let t = this;
        window.addEventListener('hashchange', function (e) {
            this.oldUrl = e.oldURL;
            this.newUrl = e.newURL;
            let hash = location.hash.split('@R/')[1];
            t.trigger(hash);
        });
        window.addEventListener('load', function () {
            let hash = location.hash.split('@R/')[1]
            t.trigger(hash);
        })
    };


    initRegexps(route) {
        route = route.replace(/[/,.+\-?$#{}\[\]]/g, '\\$&')
            .replace(/\((.*?)\)/g, '(?:$1)?')
            .replace(/(\/\w?:\w+)+/g, '\/([^/]+)')
            .replace(/\*\w*/g, '([^?]*?)');

        return new RegExp('^' + route + '$');
    };

    //将匹配的正则返回,为回调函数提供参数
    getParams(reg, hash) {
        return reg.exec(hash).slice(1);
    }


    /**
     * 
     * @param {string} url 地址
     * @param {any} param 
     */
    navgator(url, param) {
        location.href = '#' + url;
        urlParam.set(url, param)
    }

    getParam(hash) {
        let paramObj = {};
        if (hash.indexOf("?") != -1) {
            let str = url.substr(1);
            let paramStr = str.split("&");
            for (let i = 0; i < paramStr.length; i++) {
                let paramd = paramStr[i].split("=");
                paramObj[paramd[0]] = decodeURI(paramd[1]);
            }
        }
        return paramObj
    }
}